import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ru from './ru';

/**
 * i18next bootstrap for the portal. RU is the only shipped locale, bundled inline
 * (no async backend) so strings are ready synchronously before first render.
 * Single default namespace `portal`.
 */
export const defaultNS = 'portal';

export const resources = {
  ru: { portal: ru },
} as const;

if (!i18n.isInitialized) {
  void i18n.use(initReactI18next).init({
    resources,
    lng: 'ru',
    fallbackLng: 'ru',
    defaultNS,
    ns: ['portal'],
    interpolation: { escapeValue: false },
    returnNull: false,
  });
}

export default i18n;
